import React from 'react';
import { Link } from 'react-scroll';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.min.css';

const roadmapStages = [
    {
        title: 'BASIC VIDEO',
        salePrice: '$650',
        actualPrice: '$325',
        off: '50%',
        items: [
            '30 Second Video', 'Professional Script', 'Custom Design', 'Storyboard', 'Custom Animation', 'Voice Over & Sound Effects', '4 Weeks Delivery'
        ]
    },
    {
        title: 'STARTER VIDEO',
        salePrice: '$1250',
        actualPrice: '$625',
        off: '50%',
        items: [
            '60 Second Video', 'Professional Script', 'Custom Design', 'Storyboard', 'Custom Animation', 'Voice Over & Sound Effects', '5 Weeks Delivery'
        ]
    },
    {
        title: 'PROFESSIONAL VIDEO',
        salePrice: '$2250',
        actualPrice: '$1125',
        off: '50%',
        items: [
            '90 Second Video', 'Professional Script', 'Custom Design', 'Storyboard', 'Custom Animation', 'Voice Over & Sound Effects', '6 Weeks Delivery'
        ]
    },
    {
        title: 'ELITE VIDEO',
        salePrice: '$3250',
        actualPrice: '$1625',
        off: '50%',
        items: [
            '120 Second Video', 'Professional Script', 'Custom Design', 'Storyboard', 'Custom Animation', 'Voice Over & Sound Effects', '100% Ownership Rights'
        ]
    },
    {
        title: 'CORPORATE VIDEO',
        salePrice: '$4450',
        actualPrice: '$2225',
        off: '50%',
        items: [
            '180 Second Video', 'Professional Script', 'Custom Design', 'Storyboard', 'Custom Animation', 'Voice Over & Sound Effects', '100% Ownership Rights'
        ]
    },
    {
        title: '3D VIDEO BASIC',
        salePrice: '$4450',
        actualPrice: '$2225',
        off: '50%',
        items: [
            '30 Second 3D Video', 'Professional Script', 'Custom Design', 'Storyboard', 'Custom Animation', 'Voice Over & Sound Effects', '100% Ownership Rights'
        ]
    },
    {
        title: '3D VIDEO STARTER',
        salePrice: '$6900',
        actualPrice: '$3450',
        off: '50%',
        items: [
            '60 Second 3D Video', 'Professional Script', 'Custom Design', 'Storyboard', 'Custom Animation', 'Voice Over & Sound Effects', '100% Ownership Rights'
        ]
    },
    {
        title: '3D VIDEO PROFESSIONAL',
        salePrice: '$8,900',
        actualPrice: '$4450',
        off: '50%',
        items: [
            '90 Second 3D Video', 'Professional Script', 'Custom Design', 'Storyboard', 'Custom Animation', 'Voice Over & Sound Effects', '100% Ownership Rights'
        ]
    },
    {
        title: '3D VIDEO ELITE',
        salePrice: '$9300',
        actualPrice: '$4650',
        off: '50%',
        items: [
            '90 Second 3D Video', 'Professional Script', 'Custom Design', 'Storyboard', 'Custom Animation', 'Voice Over & Sound Effects', '100% Ownership Rights'
        ]
    },
    {
        title: 'GOLDEN VIDEO PACKAGE',
        salePrice: '$29,705',
        actualPrice: '$14,852',
        off: '50%',
        items: [
            '3D Video Elite Included', 'High-Quality Work & Years of Experience', '100% Satisfaction Guarantee', '100% Money-Back Guarantee', 'Fantastic Free Add-ons'
        ]
    },
    {
        title: 'PLATINUM VIDEO PACKAGE',
        salePrice: '$49,405',
        actualPrice: '$24,702',
        off: '50%',
        items: [
            'Golden Video Included', 'High-Quality Work & Years of Experience', '100% Satisfaction Guarantee', '100% Money-Back Guarantee', 'Fantastic Free Add-ons'
        ]
    },
];

const Packages = () => {
    return (
        <section id="packages" className="meme_roadmap_section section_space">
            <div className="container">
                <div className="memecoin_heading_block text-center" data-aos="fade-up" data-aos-duration="800">
                    <h2 className="heading_text text-uppercase mb-0">CHOOSE FROM VARIOUS PRICING PLANS!</h2>
                </div>

                <div className="meme_roadmap_carousel">
                    <Swiper
                        loop={true}
                        spaceBetween={30}
                        grabCursor={false}
                        centeredSlides={true}
                        breakpoints={{
                            0: { slidesPerView: 1 },
                            991: { slidesPerView: 2 },
                            1025: { slidesPerView: 3 },
                            1700: { slidesPerView: 3 },
                        }}
                    >
                        {roadmapStages.map((stage, index) => (
                            <SwiperSlide key={index}>
                                <div className="meme_roadmap_block">
                                    <div className="roadmap_info">
                                        <h3 className="roadmap_title text-uppercase">{stage.title}</h3>
                                        <div className='d-flex gap-3 pb-5 pt-4'>
                                            <p style={{ fontSize: '40px', fontWeight: 'bold' }}>{stage.salePrice}</p>
                                            <p style={{ marginTop: '6px' }}><del>{stage.actualPrice}</del></p>
                                            <p style={{ marginTop: '6px' }}>{stage.off} OFF</p>
                                        </div>
                                        <ul className="iconlist_block unordered_list_block">
                                            {stage.items.map((item, itemIndex) => (
                                                <li key={itemIndex}>
                                                    <span className="iconlist_icon">
                                                        <i className="fa-regular fa-square-check"></i>
                                                    </span>
                                                    <span className="iconlist_label">{item}</span>
                                                </li>
                                            ))}
                                        </ul>
                                        <Link className="memecoin_btn mt-5 px-4 py-3 text-uppercase" style={{ backgroundColor: '#000', borderRadius: '30px', fontSize: '18px', letterSpacing: '1px' }} to="/token">
                                            Order Now
                                        </Link>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </section>
    );
};

export default Packages;
